import { basicTask } from "./task";
import { swiperInit } from "./swiper";

gsap.registerPlugin(ScrollTrigger);

const bodyWrap = document.querySelector("body");
const sideNav = document.querySelector(".sidenav-group");
const hamburger = document.querySelector(".hamburger");
const menuMobile = document.querySelector(".mobile-nav-wrap");
const searchWrap = document.querySelector(".search-overlay");


document.addEventListener("DOMContentLoaded", () => {
	mappingFunc();
	const observer = lozad(".lozad", {
		rootMargin: "10px 0px", // syntax similar to that of CSS Margin
		threshold: 0.1, // ratio of element convergence
		enableAutoReload: true, // it will reload the new image when validating attributes changes
	});
	observer.observe();
	window.lozadObserver = observer;
	try {
		if ($(window).width() > 1200.1) {


		}
	} catch (error) { }
	swiperInit();
	viewShowMoreRecruit();
	basicTask();
	generalFunction.init();
});

window.addEventListener("resize", function () {
	let width = this.window.innerWidth;
	if (width <= 1200.1) {
		mappingFunc();
		generalFunction.init();
	}

});
window.addEventListener("scroll", function () {
	const width = this.window.innerWidth;
	const scrollTop = window.scrollY || document.documentElement.scrollTop;
	if (width >= 1200.1) {
		if (
			document.body.scrollTop > 100 ||
			document.documentElement.scrollTop > 100
		) {
			bodyWrap.classList.add("minimize");
		} else {
			bodyWrap.classList.remove("minimize");
		}
	}
	if (scrollTop > window.innerHeight) {
		sideNav.classList.add("show");
	} else {
		sideNav.classList.remove("show");
	}
});
document.addEventListener("click", (event) => {
	if (!event.target.closest(".search-toggle, .search-overlay")) {
		searchWrap.classList.remove("is-open");
	}
	if (!event.target.closest(".mobile-nav-wrap, .site-menu-toggle")) {
		menuMobile.classList.remove("is-open");
		bodyWrap.classList.remove("overlay-bg");
		hamburger.classList.remove("is-active");
	}
});

Fancybox.bind("[data-fancybox]", {
	parentEl: document.body[0], // Element containing main structure
});

const generalFunction = {



	counterRoller: () => {
		
		try {



			var $countWrap = $(".counter-roller").find(".digit");
			var $boxWrap = $(".box_wrap");
			var count = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
			var duration = 1.5;

			$countWrap.each(function (idx, target) {
				var $target = $(target);
				var currentCount = $target.data("current"),
					repeat = $target.data("repeat"),
					direction = $target.data("direction");
				var html = '<ul>';

				// Generate roulette HTML
				for (var e = 0; e < repeat + 1; e++) {
					for (var i = 0; i < count.length; i++) {
						var countIndex = direction === 'down' ? count.length - 1 - i : i;
						html += `<li data-count="${countIndex}">${count[countIndex]}</li>`;
					}
				}
				html += '</ul>';
				$target.html(html);

				var $transformWrap = $target.find("ul");
				var listLength = $target.find("li").length;
				var listHeight = $countWrap.height();

				// Movement function
				function animateMove() {
					var endY = direction === 'down'
						? -(((listLength - 1) - (repeat * count.length) - currentCount) * listHeight)
						: -((listLength - count.length + currentCount) * listHeight);

					gsap.timeline({
						scrollTrigger: {
							trigger: $target,
							start: 'top 90%', // Adjust start point
							end: 'bottom 25%', // Optional: Define when to end
							toggleActions: 'play pause resume reset',
							onEnter: function () {
								$boxWrap.addClass("active");
							},
							onLeaveBack: function () {
								$boxWrap.removeClass("active");
							},
						},
					}).fromTo($transformWrap, {
						y: direction === 'down' ? -((listLength - 1) * listHeight) : 0,
					}, {
						y: endY,
						duration: duration,
					});
				}

				ScrollTrigger.matchMedia({
					"(min-width: 768px)": function () {
						animateMove();
					},
					"(max-width: 767px)": function () {
						animateMove();
					}
				});
			});
		} catch (error) {

		}

	},

	hideElement: () => {
		if ($(window).width() < 1200.1) {
			[".language-wrap", ".nav-primary-menu",".header-contact"]
				.map((selector) => document.querySelector(selector))
				.forEach((el) => (el.style.display = "flex"));
		}
	},
	init: () => {
		generalFunction.hideElement();
		generalFunction.counterRoller();
	},

	
};



function mappingFunc() {
	new MappingListener({
		selector: ".language-wrap",
		mobileWrapper: ".mobile-top-nav",
		mobileMethod: "appendTo",
		desktopWrapper: ".search-wrap",
		desktopMethod: "insertAfter",
		breakpoint: 1200.1,
	}).watch();
	new MappingListener({
		selector: ".nav-primary-menu",
		mobileWrapper: ".mobile-nav-wrap",
		mobileMethod: "appendTo",
		desktopWrapper: ".search-wrap",
		desktopMethod: "insertBefore",
		breakpoint: 1200.1,
	}).watch();
	new MappingListener({
		selector: ".header-contact",
		mobileWrapper: ".mobile-nav-wrap",
		mobileMethod: "appendTo",
		desktopWrapper: ".site-menu-toggle",
		desktopMethod: "insertBefore",
		breakpoint: 1200.1,
	}).watch();
}
function viewShowMoreRecruit() {
	$(".btn-show-more").on("click", function () {
		const textNode = $(this).data("expand");
		const textNodeActive = $(this).data("compact");
		if ($(this).hasClass("active")) {
			$(this)
				.closest(".recruit-list")
				.find("tr:nth-child(n+3)")
				.addClass("show");
			$(this).find("span").text(textNode);
		} else {
			$(this)
				.closest(".recruit-list")
				.find("tr:nth-child(n+3)")
				.removeClass("show");
			$(this).find("span").text(textNodeActive);
		}
		$(this).toggleClass("active");
	});
}
